import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=c56d3720&scoped=true"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=c56d3720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56d3720",
  null
  
)

export default component.exports